<template>
  <div id="hydwrh">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hydwrh'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/membership/company/Hydwrh.vue